/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const InstagramFill = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M13.03 2c1.12 0 1.7 0 2.19.02l.2.01.7.03c1.07.05 1.8.22 2.43.47.66.25 1.22.6 1.77 1.15.56.55.9 1.11 1.16 1.77.24.64.41 1.36.46 2.43l.03.71v.2l.03 2.18v2.06c0 1.12 0 1.7-.02 2.19v.19l-.04.71a7 7 0 0 1-.46 2.43c-.26.66-.6 1.22-1.16 1.77-.55.56-1.11.9-1.77 1.16a7 7 0 0 1-2.43.46l-.7.03h-.2c-.5.02-1.07.03-2.2.03h-2.05c-1.12 0-1.7 0-2.19-.02H8.6l-.71-.04a7 7 0 0 1-2.43-.46 5 5 0 0 1-1.77-1.16 5 5 0 0 1-1.15-1.77 7 7 0 0 1-.47-2.43l-.03-.71v-.2C2 14.73 2 14.16 2 13.04v-2.06c0-1.12 0-1.7.02-2.19l.01-.19.03-.71c.05-1.07.22-1.8.47-2.43.25-.66.6-1.22 1.15-1.77a5 5 0 0 1 1.77-1.15 7 7 0 0 1 2.43-.47l.71-.03h.2L10.96 2zM12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10m0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6m5.25-3.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" />
  </Icon>
);
